import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import RouteSeo from "./RouteSeo";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="theme-page min-h-screen font-body antialiased transition-colors duration-300">
      <RouteSeo />
      <Header />
      <main id="main-content" className="pt-[88px] lg:pt-[148px]">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
